<template>
  <div class="hot-topic">
    <div class="hot-topic-title">推荐专题</div>
    <topic-card  v-for="(item, index) in hotTopics"  :hotTopic="item"  :key="index"></topic-card>
  </div>
</template>
<script>
import TopicCard from './TopicCard'
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'hot-topic',
  components: {TopicCard},
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('topic', ['hotTopics'])
  },
  methods : {
    ...mapActions('topic', ['getHotTopics'])
  },
  created () {
    this.getHotTopics()
  }
}
</script>
<style lang="scss" scoped>
.hot-topic{
  height: 400px;
  >.hot-topic-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    height: 60px;
    line-height: 60px;
  }
}
</style>


